<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 unnumbered" id="james-stories">
<h1></h1>
<h1 class="unnumbered" style="text-transform: uppercase;letter-spacing:3px;font-size:15pt;font-family:Garamond"><span style="font-size:18pt">J</span>ames Stories</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?e33b3d84